




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import 'vue-json-pretty/lib/styles.css';
import { Getter } from 'vuex-class';
import Header from '@/components/Header.vue';

@Component({
  components: {
    Header,
  },
})
export default class DemoResult extends Vue {
  @Getter responseData!: any;

}
